import type { LegacyGatewaySummary } from '../../api/notices';

// Names and sites come from the customer's controller, so a value starting with one of these is
// prefixed with ' to stop a spreadsheet from running it as a formula (OWASP CSV injection).
const FORMULA_START = /^[=+\-@\t\r]/;

function cell(value: string): string {
  const safe = FORMULA_START.test(value) ? `'${value}` : value;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

// Sorted by site: customers use the file to plan replacements site by site.
export function gatewaysCsv(gateways: LegacyGatewaySummary[]): string {
  const sorted = [...gateways].sort((a, b) => a.site.localeCompare(b.site) || a.name.localeCompare(b.name));
  const rows = [
    ['Site', 'Name', 'Model', 'Status'],
    ...sorted.map((g) => [g.site, g.name, g.model, g.online ? 'Online' : 'Offline']),
  ];
  return rows.map((r) => r.map(cell).join(',')).join('\r\n') + '\r\n';
}

// A data: URL rather than a Blob so the link is plain markup: no click handler and no object URL
// to revoke. The BOM makes Excel read the file as UTF-8 (site names with accents).
export function gatewaysCsvHref(gateways: LegacyGatewaySummary[]): string {
  return `data:text/csv;charset=utf-8,${encodeURIComponent(`\uFEFF${gatewaysCsv(gateways)}`)}`;
}

export function gatewaysCsvFilename(hostname: string): string {
  return `usg-gateways-${hostname}.csv`;
}
